



































































































































































































import Vue from 'vue';
import moment from 'moment-timezone';
import _ from 'lodash';

import Requester from '../../requester';

import CustomDialog from '../CustomDialog.vue';
import { TipoParto, GestacaoAnteriorFormData } from '../../../../back/src/types';
import { sexoBebeItensFinalizar, tipoPartoItens } from '../../utils/constants';
import { Paciente } from '../../../../back/src/entity/Paciente';

export default Vue.extend({
  name: 'TheGestacoesAnterioresFormDialog',
  components: {
    CustomDialog,
  },
  props: {
    paciente: {
      type: Object as () => Paciente,
    },
  },
  data() {
    return {
      dialog: false,
      valid: false,
      menuDataParto: false,
      loading: false,
      form: {
        dataParto: '',
        horarioParto: '',
        tipoParto: null,
        gestacaoGemelar: false,
        igSemanas: '',
        igDias: '',
        sexo1: '',
        nome1: '',
        peso1: null,
        sexo2: '',
        nome2: '',
        peso2: null,
        observacoes: '',
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório.',
        ],
        hora: [
          (v: string) => {
            const timePattern: RegExp = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
            return (!v || (v && timePattern.test(v))) || 'Horário inválido';
          },
        ],
        date: [
          (v: string) => !!v || 'Campo obrigatório',
          (v: string) => {
            if (!v) return true;
            const date = v.split('/').reverse().join('-');
            const momentDate = moment(date);
            return (v && momentDate.isValid() && momentDate.isAfter('1900-01-01'))
              || 'Data inválida';
          },
        ],
      },
      items: {
        sexoBebe: sexoBebeItensFinalizar,
        tipoParto: tipoPartoItens,
      },
    };
  },
  computed: {
    vRowClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex flex-column';
      }
      return '';
    },
    vColClass(): string {
      return 'pt-1 pb-2';
    },
    vColLabelClass(): string {
      return 'pt-1 pb-2 mb-1';
    },
    rulesHorarioParto(): any[] {
      if (this.form.tipoParto === TipoParto.N || this.form.tipoParto === TipoParto.C) {
        return _.concat(this.rules.required, this.rules.hora);
      }
      return this.rules.hora;
    },
    formGestacoesAnteriores(): Vue & { validate: () => boolean, resetValidation: () => void } {
      return this.$refs.formGestacoesAnteriores as Vue & {
        validate: () => boolean,
        resetValidation: () => void
      };
    },
  },
  methods: {
    avaliaInt(val: string) {
      return Number.isNaN(parseInt(val, 10)) ? null : parseInt(val, 10);
    },
    datetimeParto(data: string, horario: string): Date | null {
      const dateString = this.form.dataParto.split('/').reverse().join('-');
      let momentDatetimeParto: moment.Moment;
      if (!horario) {
        momentDatetimeParto = moment(dateString);
      } else {
        momentDatetimeParto = moment(`${dateString} ${this.form.horarioParto}`);
      }
      return momentDatetimeParto.isValid() ? momentDatetimeParto.toDate() : null;
    },
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm() {
      this.loading = true;
      if (!this.formGestacoesAnteriores.validate()) {
        this.loading = false;
        return;
      }
      const formData: GestacaoAnteriorFormData = {
        Gestacao: {
          paciente_id: this.paciente.id,
          atual: false,
          gestacao_anterior: true,
          gestacao_gemelar: this.form.gestacaoGemelar,
          ig_semanas: this.avaliaInt(this.form.igSemanas),
          ig_dias: this.avaliaInt(this.form.igDias),
          nome1: this.form.nome1,
          sexo1: this.form.sexo1,
          nome2: this.form.gestacaoGemelar ? this.form.nome2 : null,
          sexo2: this.form.gestacaoGemelar ? this.form.sexo2 : null,
          ended: moment().toDate(),
        },
        Parto: {
          paciente_id: this.paciente.id,
          data_parto: this.datetimeParto(this.form.dataParto, this.form.horarioParto),
          tipo_parto: this.form.tipoParto,
          peso1_gramas: this.form.peso1 || null,
          peso2_gramas: this.form.gestacaoGemelar ? this.form.peso2 : null,
          observacoes: this.form.observacoes,
        },
      };
      try {
        const response = await Requester.gestacao.criaGestacaoAnterior(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.dialog = false;
          this.$emit('adiciona-gestacao-anterior', response.data);
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Gestação registrada com sucesso!' });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
  },
});
